

































import Vue from 'vue'
import { SystemBasicInfo, SystemNetwork } from '@/types/api'
import moment from 'moment'
import easyapi from '@/easyapi'

let INTERVAL_ID = -1
export default Vue.extend({
  computed: {
    basicInfo (): SystemBasicInfo { return this.$s.$state.sys.basicInfo },
    networkStatus (): SystemNetwork { return this.$s.$state.sys.network.status },
    uptime (): string { return moment.duration(this.basicInfo.uptime * 1000).humanize() },
    dateTime (): string { return moment(this.basicInfo.date * 1000).format('YYYY/MM/DD HH:mm:ss') },
    ramPerc (): number { return ~~((this.basicInfo.ramUsage / this.basicInfo.ramTotal) * 100) },
    diskPerc (): number { return ~~((this.basicInfo.diskUsage / this.basicInfo.diskTotal) * 100) },
    cpu (): string { return `${~~this.basicInfo.cpu} %` },
    ram (): string { return `${this.ramPerc} % (${this.basicInfo.ramUsage} MB / ${this.basicInfo.ramTotal} MB)` },
    disk (): string { return `${this.diskPerc} % (${this.basicInfo.diskUsage} MB / ${this.basicInfo.diskTotal} MB)` },
  },
  mounted () {
    INTERVAL_ID = window.setInterval(easyapi.fetchSystemBasicInfo, 2000)
  },
  beforeDestroy () {
    window.clearInterval(INTERVAL_ID)
  }
})
